const invitationTypes = {
    ORGANIZER_TO_EXHIBITOR: "ORGANIZER_TO_EXHIBITOR",
    ORGANIZER_TO_ORGANIZER: "ORGANIZER_TO_ORGANIZER",
    EXHIBITOR_TO_EXHIBITOR: "EXHIBITOR_TO_EXHIBITOR",
};

export default invitationTypes;
